import { Controller } from "@hotwired/stimulus"
import Chart from 'chart.js/auto'
import 'chartjs-adapter-date-fns'

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    this.renderChart()
  }

  renderChart() {
    const ctx = this.element.getContext('2d')

    // Transform data from hash to Chart.js format
    const datasets = Object.entries(this.dataValue).map(([label, data]) => {
      let color
      if (label === 'Completed') {
        color = '#10b981' // green
      } else if (label === 'Running') {
        color = '#0ea5e9' // blue
      } else {
        color = '#ef4444' // red
      }

      return {
        label: label,
        data: data.map(([time, value]) => ({
          x: new Date(time),
          y: value
        })),
        borderColor: color,
        backgroundColor: color + '20', // Add transparency
        tension: 0.4,
        fill: true
      }
    })

    new Chart(ctx, {
      type: 'line',
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          },
          x: {
            type: 'time',
            time: {
              unit: 'hour',
              displayFormats: {
                hour: 'HH:mm'
              }
            }
          }
        },
        interaction: {
          mode: 'index',
          intersect: false
        }
      }
    })
  }
}
